import { parseMcleodDate } from "../utils/dateHelpers";
import { nullCheck } from "../utils/dataHelpers";

export default class CallInLogSerializer {
  static logDeSerializer(data) {
    return {
      ...data,
      callDateTime: parseMcleodDate(data.call_date_time),
      city: data.city_name,
      state: data.state,
      initiatedType: nullCheck(data, null, "initiated_type"),
      enteredBy: nullCheck(data, null, "entered_by"),
      comments: data.remark,
      callinStatus: data.callin_status,
      nextStopCity: data.next_stop_city_name,
      nextStopState: data.next_stop_state,
      newEta: parseMcleodDate(data.new_eta),
      distanceNextStop: data.miles2consignee
    };
  }

  static callInLogDeserializer(data) {
    return {
      callins: data.callins.map(c => this.logDeSerializer(c))
    };
  }

}